import React from "react";
import "./Card.sass";
import {ReactComponent as Logo} from "../../images/release/game/card/logo-card.svg";

export default function Card({isOpened, Icon, onClick}) {
    return (
        <div className="Card-wrapper" onClick={onClick}>
            {isOpened ? <Icon/> : <Logo/>}
        </div>
    )
}